
export const prototypeName = 'Servicebund.RodeoSteakDe:Component.Pin';